import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigurationsProvider } from '@store/configuration/ConfigurationsProvider';
import { App } from './App';
import { unregister } from './serviceWorker';

console.log('/////////////////// APP (RE-)LOADED ///////////////////');

ReactDOM.render(
  <React.StrictMode>
    <ConfigurationsProvider>
      <App />
    </ConfigurationsProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregister();
